import type { Appearance } from '@atlaskit/button/old-button/types';
import type { PositionType } from '@atlaskit/tooltip/types';

export const ACTION_SUBJECT_ID = 'copyShareLink';

export enum PAGE_MODE {
	VIEW = 'view',
	EDIT = 'edit',
}

export type CopyLinkProps = {
	pageMode?: PAGE_MODE;
	contentType: string;
	contentId: string;
	spaceKey: string;
	source: string;
	shouldResetOnHover?: boolean;
	buttonAppearance?: Appearance;
	tooltipPosition?: PositionType;
	/**
	 * The ID of the element that labels this button for accessibility purposes.
	 * For example, if the button is visually labelled by a heading, that heading's ID
	 * can be passed here so screen readers can associate the button with the content
	 * for which it is copying the link.
	 */
	referencedContentId?: string;
};
